
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { getStoreImage, getValidatedImage } from "./thumbnails";

// Shows the full size image on hover. Pass imageId for a store image or
// validatedPlu for the image saved in the standard product list.
@Component
export default class ImagePreview extends Vue {
  @Prop()
  imageId?: number;
  @Prop()
  validatedPlu?: string;

  image: string | null = null;
  loading: boolean = false;

  get hasImage() {
    return this.imageId !== undefined || this.validatedPlu !== undefined;
  }

  @Watch("imageId")
  @Watch("validatedPlu")
  sourceChanged() {
    this.image = null;
  }

  async onVisibleChange(visible: boolean) {
    if (!visible || this.image || this.loading) return;
    let imageId = this.imageId;
    let plu = this.validatedPlu;
    this.loading = true;
    try {
      let result =
        imageId !== undefined
          ? await getStoreImage(imageId)
          : await getValidatedImage(plu ?? "");
      if (imageId === this.imageId && plu === this.validatedPlu) this.image = result;
    } catch {
      this.image = null;
    } finally {
      this.loading = false;
    }
  }
}
